<template>
  <div class='sms-input' ref="editor" @drop.prevent="false"></div>
</template>

<script>
import Quill from 'quill'
import Delta from "quill-delta";
import { debounce } from "lodash";

export default {
  name: "editor",

  props: {
    value: String,
    debounce: {
      type: Number,
      default: 1000
    }
  },

  data() {
    return {
      quill: null
    }
  },

  mounted() {
    this.injectQuill()
  },

  watch: {
    value(newValue) {
      this.quill.setText(newValue);
    }
  },

  methods: {
    injectQuill() {
      this.quill = new Quill(this.$refs.editor, {
        modules: { toolbar: false, subLabel: {} },
        theme: 'snow'
      })

      this.quill.root.setAttribute('spellcheck', false)
      this.quill.root.setAttribute('data-cy', 'stashboard-content-editor')
      this.quill.clipboard.addMatcher(Node.TEXT_NODE, (node, delta) => {
        if(node.parentElement && node.parentElement.tagName === 'SPAN' && node.data === this.mockUrl) {
          return new Delta();
        }

        return delta;
      });

      this.quill.setText(this.value)
      this.quill.on('text-change', debounce(() => {
        if(this.quill.getText().trim() !== this.value) {
          this.$emit('update:value', this.quill.getText())
        }
      }, this.debounce))

      this.$el.querySelector('.ql-editor').addEventListener('blur', () => this.$emit('blur'))
    },

    insertText(text) {
      const cursorIndex = this.quill.getSelection(true) ? this.quill.getSelection(true).index : 0;
      this.quill.insertText(cursorIndex, text);
    },
  }
}
</script>

<style scoped>
  .sms-input {
    height: 275px;
    border: 1px solid #128ff9;
    border-bottom: none;
    font-size: 16px;
    font-family: AileronLight;
    font-weight: 400;
  }

  .sms-input .ql-editor {
    padding: 10px 8px;
  }
</style>
